import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const linear = defineConnector({
  identifier: "linear",
  name: "Linear",
  tagLine: "Issue tracking for teams",
  keywords: "issues tickets bugs projects cycles roadmap graphql",
  logo,
  protocol: "http",
  tags: ["featured", "engineering", "productivity"],
  defaultUrlPattern: () => "https://api\\.linear\\.app/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get a personal API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Linear API settings](https://linear.app/settings/api) and create a new personal API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Linear API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.linear.app/graphql",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{ viewer { id } }" }),
    }),
  },
});
